import { createZodDto } from './zod';

import { z } from 'zod';

const mappedHeader = z.string().min(1).nullable().optional();

export const userImportMappingSchema = z.object({
  id: mappedHeader,
  email: mappedHeader,
  firstName: mappedHeader,
  lastName: mappedHeader,
  phone: mappedHeader,
  role: mappedHeader,
  comment: mappedHeader,
  externalUserId: mappedHeader,
  language: mappedHeader,
  isDeactivated: mappedHeader,
  folderNames: mappedHeader,
});

const analyzeUserImportSchema = z.object({
  organizationId: z.coerce.number().int().positive(),
  fileKey: z.string().min(1).optional(),
  /** JSON-encoded UserImportMapping, sent as a multipart form field */
  mapping: z.string().optional(),
});

export class AnalyzeUserImportDto extends createZodDto(
  analyzeUserImportSchema,
) {}

const executeUserImportSchema = z.object({
  fileKey: z.string().min(1),
  organizationId: z.number().int().positive(),
  mapping: userImportMappingSchema,
  inviteNewUsers: z.boolean(),
});

export class ExecuteUserImportDto extends createZodDto(
  executeUserImportSchema,
) {}
